import $ from 'jquery';
import {debounce} from 'debounce';

export default class ProductCard {
  constructor(options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          item: '.product-card',
          image: '.product-card__image',
          hoverImage: '.product-card__hover-image',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.bind();
  }

  /**
   * Apply event listeners
   */
  bind() {
    $(document).on(
      'mouseenter focus',
      this.options.selectors.item,
      debounce(this.handleMouseEnter.bind(this), 150),
    );

    $(document).on(
      'mouseleave blur',
      this.options.selectors.item,
      this.handleMouseLeave.bind(this),
    );
  }

  /**
   * @param {Event} event
   */
  handleMouseEnter(event) {
    const $target = $(event.currentTarget);

    this.swapImage($target, true);
    $target.toggleClass(this.options.classes.active, true);
  }

  /**
   * @param {Event} event
   */
  handleMouseLeave(event) {
    const $target = $(event.currentTarget);

    if (this.$clicked && this.$clicked.is($target)) {
      return;
    }

    this.swapImage($target, false);
    $target.toggleClass(this.options.classes.active, false);
  }

  /**
   * @param {jQuery} target
   * @param {Boolean} state
   */
  swapImage(target, state) {
    const $image = target.find(this.options.selectors.image);
    const $hoverImage = target.find(this.options.selectors.hoverImage);

    if (!$hoverImage.length) {
      return;
    }

    $image.toggleClass(this.options.classes.active, !state);
    $hoverImage.toggleClass(this.options.classes.active, state);
  }
}
